@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

@thin-grey-border: 1px solid @product-page--grid--border-color;

.grid-subcontainer() {
  display: flex;
}

.grid-item() {
  display: flex;
  align-items: center;
  padding: 11px 16px;
}

.grid-container {
  display: flex;
  flex-direction: column;
  border: @thin-grey-border;
  font-size: 14px;
  line-height: 20px;
  margin: 24px 0 12px;
}

.grid-header {
  .grid-subcontainer();
  border-bottom: @thin-grey-border;
  background: @product-page--total-available-header--background-color;

  .header-source {
    .grid-item();
    flex-grow: 1;
  }
  .header-item {
    .grid-item();
    width: 100px;

    &:last-child {
      justify-content: flex-end;
    }
  }
  .header-lastUpdated {
    .grid-item();
    width: 200px;
  }
}

.status {
  justify-content: center;
}

.grid-row {
  .grid-subcontainer();
  border-bottom: none;
  background: @product-page--grid-row--background-color;

  &.group-footer {
    border-bottom: @thin-grey-border;
  }
  &:last-of-type {
    border-bottom: none;
  }

  .grid-source {
    .grid-item();
    flex-grow: 1;

    &.no-icon-name {
      padding-left: 37px;
    }
  }
  .grid-item {
    .grid-item();
    width: 100px;

    &:last-of-type {
      justify-content: flex-end;
    }
  }
  .grid-lastUpdated {
    .grid-item();
    width: 200px;
  }
}

.body-description {
  display: flex;
}

.total {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 16px 0 4px;
  border-right: @product-page--grid--border-color 1px solid;
}

.quantity {
  font-size: 28px;
  line-height: 1.25;
}
.available {
  font-size: 14px;
  line-height: 20px;
}

.name-description {
  padding-left: 16px;
  max-width: 100%;
  overflow: hidden;
}
.name {
  font-weight: @bold;
  line-height: 20px;
}
.description {
  margin-top: 4px;
  font-size: 14px;
  line-height: 20px;
}

.modal-body {
  padding: 20px;
}

.store-icon {
  margin-right: 5px;
}

.store-icon,
.status-active,
.status-warning,
.inactive-connection-icon {
  width: 16px;
  height: 16px;
}

.available-quantity {
  padding: 2px 10px;
}

.show-warning {
  color: @product-page--grid-row-icon--warning--text-color;
}

.inactive-connection-icon {
  color: @product-page--grid-row-icon--warning--text-color;
  margin-left: 10px;
}

.status-active {
  color: @product-page--grid-row-status--active--text-color;
}

.status-warning {
  color: @product-page--grid-row-status--warning--text-color;
}

.header {
  display: flex;
  gap: 8px;
  align-items: center;
}

.icon {
  height: 16px;
  vertical-align: middle;
  color: @product-page--grid-row-icon--fill-color;
}

.column-contents {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: flex-end;
}

.empty-total-available {
  padding: 2px 10px;
}
